import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch } from "react-redux";
import {
  createHeader,
  getParticularforupdate,
  updateHeader,
  uploadImage,
} from "../../redux/actions/addCampaigndata";
import { Add } from "@mui/icons-material";
import { Button, Checkbox, FormControlLabel, Grid, MenuItem, Toolbar } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TextField from "@mui/material/TextField";
import Tooltip from '@mui/material/Tooltip';
import { Toastify } from "../../services/toastify/toastifyContainer";
import "./styles/headerdata.css";
import schema from './comman/HeaderValidations'
import ImageModal from "./comman/Modal";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import StarRateIcon from '@mui/icons-material/StarRate';
import ImageWithDeleteButton from "../Update_Campaign/comman/imageContainer";
import { color, motion } from "framer-motion";


const HeaderCreation = (props) => {
  const { handleNext, activeStep, handleBack } = props;
  const dispatch = useDispatch();


  // collapse state
  const [columnVisibility, setColumnVisibility] = useState({
    leftNavLogo: false,
    rightNavLogo: false,
    navLists: false,
    seoData: false,
  });

  const toggleColumn = (columnName) => {
    setColumnVisibility({
      ...columnVisibility,
      [columnName]: !columnVisibility[columnName],
    });
  };


  // for images
  const [imageLinks, setImageLinks] = useState({
    left_nav_logo: "",
    nav_right_logo: "",
    share_image: "",
  });
  const [imageMessage, setImageMessage] = useState({
    left_nav_logo: true,
    nav_right_logo: true,
    share_image: true,
  });


  const {
    control,
    handleSubmit,
    formState: { errors },
    register,
    clearErrors,
    setError,
    setValue,
    watch,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),

    defaultValues: {
      left_nav_logo: { file: null, link: "", alt: "", target: "_self", image: "" },
      nav_right_logo: { file: null, link: "", alt: "", target: "_self", image: "" },
      uiType: localStorage.getItem("uiType") || "",
      navList: [{ text: "", link: "", target: "", order: null }],
      seo_title: "",
      seo_description: "",
      seo_keywords: "",
      share_image: "",
      share_title: "",
      share_description: "",
      campaign_type: localStorage.getItem("campaign_type") || "",
      seoDone: false,
      pay_method: "",
      favicon: ""
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "navList",
  });


  const validateImage = (file) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = URL.createObjectURL(file);

      image.onload = () => {
        const width = image.width;
        const height = image.height;
        const size = file.size / 1024;
        if (size >= 50) {
          reject("Image size exceeds 50KB limit.");
        }
        if (width >= 401 || height >= 211) {
          reject("File size 50KB and Intrinsic size is 400*210px.");
        }
        resolve(true);
      };
      image.onerror = () => {
        reject("Invalid image file.");
      };
    });
  };


  const handleImage = async (logo, e) => {
    const file = e.target.files[0];
    const isImage = file && file.type.startsWith("image/");

    const formData = new FormData();

    formData.append("image", file);
    if (logo === "left_nav_logo" || logo === "nav_right_logo") {

      if (file) {
        //check file size and width and height 
        try {
          await validateImage(file);
        } catch (error) {
          // Handle validation error
          console.error(error);
          Toastify({ data: "error", msg: error });
          return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
      }

      clearErrors(`${logo}.file`);
      if (!isImage) {
        setError(`${logo}.file`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`${logo}.image`, res);
        });
      }
    } else if (logo === "share_image" || logo === "favicon") {
      clearErrors(`${logo}.file`);
      if (!isImage) {
        setError(`${logo}.file`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        setImageMessage(prevState => ({
          ...prevState,
          [logo]: false,
        }));
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`${logo}.image`, res);
          setImageLinks((prevState) => ({
            ...prevState,
            [logo]: res,
          }));
        });
      }
    }
  };


  const user = localStorage.getItem("userID");
  const campaign_Id = localStorage.getItem("campaignId");
  const campaign_name = localStorage.getItem("campaign_name");

  const [deletedUrl] = useState([])

  const onSubmit = async (data) => {
    // debugger
    try {
      if (!localStorage.getItem("backClicked")) {
        localStorage.setItem("campaign_type", data?.campaign_type)
        const { file: left_nav_logo, ...leftRest } = data.left_nav_logo;
        data.left_nav_logo = leftRest;

        const { file: nav_right_logos, ...rightRest } = data.nav_right_logo;
        data.nav_right_logo = rightRest;

        const { file: share_image, ...newLogo } = data.share_image;
        data.share_image = newLogo;
        const { file: favicon, ...faviconNew } = data.favicon;
        data.favicon = faviconNew.image;

        let { uiType, campaignId, navList, nav_right_logo, ...newData } = data;

        const hasNavList = navList?.[0]?.text ? true : false
        const navRight = nav_right_logo?.image ? true : false


        const recreatedHeader = {
          ...newData,
          ui_type: uiType,
          campaign_Id: campaign_Id,
          ...(hasNavList && { nav_lists: navList }),
          ...(navRight && { nav_right_logo: nav_right_logo }),
          created_by: user,
          share_image: newLogo.image,
          campaign_name: campaign_name
        };
        const result = await dispatch(createHeader(recreatedHeader))
        if (result?.success === true) {
          handleNext();
        }
      } else {
        localStorage.setItem("campaign_type", data?.campaign_type)
        localStorage.setItem("uiType", data?.uiType)
        const { file: left_nav_logo, ...leftRest } = data.left_nav_logo;
        data.left_nav_logo = leftRest;
        const { file: nav_right_logos, ...rightRest } = data.nav_right_logo;
        data.nav_right_logo = rightRest

        const { file: shareNew, ...restShare } = data.share_image;
        data.share_image = shareNew;
        const { file: favicon, ...restFavicon } = data.favicon;
        data.favicon = restFavicon.image;

        const { navList, nav_right_logo, ...NewData } = data;

        //if navlist and nav right logo has no data then recreate the data here 
        const hasNavList = navList?.[0]?.text ? true : false
        const navRight = nav_right_logo?.image ? true : false

        const updatedHeader = {
          ...NewData,
          ...(hasNavList ? { navList: navList } : { navList: null }),
          ...(navRight ? { nav_right_logo: nav_right_logo } : { nav_right_logo: null }),
          deletedUrl: deletedUrl,
          updated_by: user,
          share_image: restShare?.image
        }
        const result = await dispatch(updateHeader(updatedHeader));
        if (result?.success === true) {
          localStorage.removeItem("backClicked")
          handleNext();
        }
      }
    } catch (error) {
      // Handle errors here
      console.error('An error occurred during form submission:', error);

    }
  };

  //when user come back for the updation
  useEffect(() => {
    if (localStorage.getItem("backClicked")) {
      let id = localStorage.getItem("updateID");
      let header = "header"
      const object = { id: campaign_Id || id, name: header }
      dispatch(getParticularforupdate(object)).then((res) => {
        setValue("left_nav_logo", res?.data?.data?.left_nav_logo);
        setValue("campaign_type", res?.data?.data?.campaign_type);
        setValue("navList", res?.data?.data?.nav_lists);
        setValue("nav_right_logo", res?.data?.data?.nav_right_logo);
        setValue("nav_right_logo.target", res?.data?.data?.nav_right_logo?.target || "");
        setValue("campaignId", res?.data?.data?.campaign_Id);
        setValue("uiType", res?.data?.data?.ui_type);
        setValue("seo_title", res?.data?.data?.seo_title);
        setValue("seo_description", res?.data?.data?.seo_description);
        setValue("seo_keywords", res?.data?.data?.seo_keywords);
        setValue("share_image", res?.data?.data?.share_image)
        setValue("share_image.image", res?.data?.data?.share_image);
        setValue("favicon.image", res?.data?.data?.favicon);
        setValue("pay_method", res?.data?.data?.pay_method);

        setValue("share_title", res?.data?.data?.share_title);
        setValue("share_description", res?.data?.data?.share_description);
        setValue("campaign_name", res?.data?.data?.campaign_name)
        setValue("seoDone", res?.data?.data?.seoDone)
        localStorage.setItem("campaignId", res?.data?.data?.campaign_Id)
        localStorage.setItem("campaign_name", res?.data?.data?.campaign_name)
        localStorage.setItem("uiType", res?.data?.data?.ui_type)
        setValue(`nav_right_logo.file`, res?.data?.data?.nav_right_logo?.image);
        setValue(`left_nav_logo.file`, res?.data?.data?.left_nav_logo?.image);
        clearErrors(`nav_right_logo.file`);
        clearErrors(`left_nav_logo.file`);
        clearErrors(`navList`);
      })
    }

  }, [setValue, dispatch])

  const [open, setOpen] = React.useState(false);

  const handleUrlChanges = (logo, e) => {
    const urlValue = e;

    // Check if the urlValue is an empty string (indicating removal)
    const isRemoving = urlValue === "";

    if (logo === "left_nav_logo" || logo === "nav_right_logo") {
      clearErrors(`${logo}.file`);
      setValue(`${logo}.image`, urlValue);
      setValue(`${logo}.file`, urlValue);
    } else if (logo === "share_image" || logo === "favicon") {
      clearErrors(`${logo}.file`);
      setValue(`${logo}.image`, urlValue);
      setImageMessage(prevState => ({
        ...prevState,
        [logo]: false,
      }));
    }
    setOpen(!open)
  };
  const GetImage = (key) => {
    localStorage.setItem("key", key)
    setOpen(true);
  }
  const handleClose = () => {
    setOpen(!open)
  }

  console.log(errors, "errors")
  return (
    <div className="">
      <form onSubmit={handleSubmit(onSubmit)}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="text-center fw-bold mb-3 border-bottom border-2 border-info pb-1"
          style={{ fontSize: "20px",color:"rgba(0, 165, 162, 0.9)" }}
        >
          Header Section
        </motion.div>
        <Row>
          <Col lg={6}>
            <div className={`toggle_btn text-bold buttons rounded-2 mb-2 ${errors.left_nav_logo ? "error" : "button"}`} style={{ cursor: "pointer" }} onClick={() => toggleColumn('leftNavLogo')}>
              Create Left Nav Logo  <StarRateIcon className={`${errors.left_nav_logo ? "text-danger" : ""}`} />  {columnVisibility.leftNavLogo ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
            </div>
            <div className="column " style={{ display: columnVisibility.leftNavLogo ? 'block' : 'none' }}>
              <div className="d-flex justify-content-around">
                <Button
                  variant="contained"
                  component="label"
                  {...register('left_nav_logo.file')}
                  onClick={() => clearErrors('left_nav_logo.url')}
                >
                  Upload File
                  <input
                    type="file"
                    {...register('left_nav_logo.file')}
                    hidden
                    onChange={(e) => handleImage("left_nav_logo", e)}
                    className={`file_button mb-1 ${errors.left_nav_logo && errors?.left_nav_logo?.file ? "error" : ""}`}
                  />
                </Button>

                {!watch(`left_nav_logo.image`) ? <Button variant="contained" component="label" onClick={() => GetImage("left_nav_logo")} >Use Images </Button> : ""}
                <ImageWithDeleteButton logoName={`left_nav_logo.image`} watch={watch} setValue={setValue} />
              </div>
              {!watch(`left_nav_logo.image`) && <p className="text-center mt-2 mb-0 text-secondary" style={{ fontSize: "10px" }}>File size 50KB and Intrinsic size is 400*150px.</p>}
              <Controller
                name={`left_nav_logo.link`}
                control={control}
                render={({ field }) => (
                  <TextField
                    // required
                    {...field}
                    // id="outlined-required"
                    label="Left Logo Link *"
                    className={`w-100 mt-3 ${errors.left_nav_logo && errors?.left_nav_logo.link
                      ? "error"
                      : ""
                      }`}
                    error={!!errors?.link}
                    helperText={errors?.link?.message}
                  />
                )}
              />
              <div className="mt-3 d-flex gap-2 ">
                <Controller
                  name={`left_nav_logo.alt`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Left Logo ALT"
                      className={`w-75  ${errors.left_nav_logo && errors?.left_nav_logo.alt
                        ? "error"
                        : ""
                        }`}
                    />
                  )}
                />
                <Controller
                  name={`left_nav_logo.target`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      required
                      select
                      {...field}
                      label="Left Logo Target"
                      className={`w-25  ${errors.left_nav_logo && errors?.left_nav_logo.target
                        ? "error"
                        : ""
                        }`}
                    >
                      <MenuItem value="_self">_self</MenuItem>
                      <MenuItem value="_blank">_blank</MenuItem>
                    </TextField>
                  )}
                />
              </div>
            </div>
            <hr className="mt-3" />
          </Col>
          <Col lg={6}>
            <div className="toggle_btn text-bold rounded-2 buttons mb-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('rightNavLogo')}>
              Create Right Nav Logo  {columnVisibility.rightNavLogo ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
            </div>
            <div className="column " style={{ display: columnVisibility.rightNavLogo ? 'block' : 'none' }}>
              <div className="d-flex justify-content-around">
                <Button
                  variant="contained"
                  component="label"
                  {...register('nav_right_logo.file')}
                >
                  Upload File
                  <input
                    type="file"
                    {...register('nav_right_logo.file')}
                    hidden
                    onChange={(e) => handleImage("nav_right_logo", e)}
                    className={`file_button mb-1 ${errors.nav_right_logo && errors?.nav_right_logo?.file ? "error" : ""}`}
                  />
                </Button>
                {!watch(`nav_right_logo`)?.image ? <Button variant="contained" component="label" onClick={() => GetImage("nav_right_logo")} >Use Images </Button> : ""}
                <ImageWithDeleteButton logoName={`nav_right_logo.image`} watch={watch} setValue={setValue} />
              </div>
              {!watch(`nav_right_logo`)?.image && <p className="text-center mt-2 mb-0 text-secondary" style={{ fontSize: "10px" }}>File size 50KB and Intrinsic size is 400*150px.</p>}
              <Controller
                name={`nav_right_logo.link`}
                control={control}
                render={({ field }) => (
                  <TextField

                    {...field}
                    id="outlined-required"
                    label="Right Logo Link *"
                    defaultValue=""
                    className={`w-100 mt-3  ${errors.nav_right_logo && errors?.nav_right_logo?.link
                      ? "error"
                      : ""
                      }`}
                  />
                )}
              />
              <div className="mt-3 d-flex gap-2">
                <Controller
                  name={`nav_right_logo.alt`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Right Logo ALT"
                      className="w-75"
                    />
                  )}
                />
                <Controller
                  name={`nav_right_logo.target`}
                  control={control}

                  render={({ field }) => (
                    <TextField
                      select
                      {...field}
                      label="Right Logo Target"
                      className={`w-25  ${errors.nav_right_logo && errors?.nav_right_logo.target
                        ? "error"
                        : ""
                        }`}
                    >
                      <MenuItem value="_self">_self</MenuItem>
                      <MenuItem value="_blank">_blank</MenuItem>
                    </TextField>
                  )}
                />
              </div>
            </div>
            <hr className="mt-3" />
          </Col>

        </Row>
        <Row>
          <Col lg={6}>
            <div >
              <div className="toggle_btn text-bold mb-2 mt-3 buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('navLists')}>
                Create Navigation Lists {columnVisibility.navLists ? <span><ExpandLessIcon /></span> : <span><ExpandMoreIcon /></span>}
              </div>
              <div style={{ display: columnVisibility.navLists ? 'block' : 'none' }}>
                {fields.map((item, index) => (
                  <div key={item.id} className="rounded-2 ">
                    <div className="column">
                      <Controller
                        name={`navList[${index}].text`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Text"
                            id="outlined-required"
                            className={`w-100 mb-3 ${errors.navList && errors?.navList[index]?.text
                              ? "error"
                              : ""
                              }`}
                          />
                        )}
                      />
                    </div>
                    <div className="column">
                      <Controller
                        name={`navList[${index}].link`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Link"
                            id="outlined-required"
                            className={`w-100 mb-3 ${errors.navList && errors?.navList[index]?.link
                              ? "error"
                              : ""
                              }`}
                          />
                        )}
                      />
                    </div>
                    <div className="column d-flex gap-2">
                      <Controller
                        name={`navList[${index}].target`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            id="outlined-required"
                            label="Enter Target"
                            select
                            className={`w-50 ${errors.navList && errors?.navList[index]?.target
                              ? "error"
                              : ""
                              }`}
                          >
                            <MenuItem value="_self">_self</MenuItem>
                            <MenuItem value="_blank">_blank</MenuItem>
                          </TextField>
                        )}
                      />
                      <Controller
                        name={`navList[${index}].order`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            select
                            label="Enter Order"
                            className={`w-50 mb-1 ${errors.navList && errors?.navList[index]?.order
                              ? "error"
                              : ""
                              }`}
                          >
                            {[...Array(15).keys()].map((number) => (
                              <MenuItem
                                key={number + 1}
                                value={(number + 1).toString()}
                              >
                                {number + 1}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                      />
                    </div>
                    <div className="column d-flex justify-content-end m-2">
                      {fields.length > 0 &&
                        <Tooltip title="Delete" arrow>
                          <DeleteIcon onClick={() => remove(index)} style={{ color: "red", cursor: "pointer" }} />
                        </Tooltip>
                      }
                    </div>
                  </div>
                ))}
                <Grid className="d-flex justify-content-between">
                  <Toolbar className="p-0">
                    <Tooltip title="Add" arrow>
                      <Button
                        className="button "
                        variant="outlined"
                        disableElevation
                        startIcon={<Add />}
                        onClick={(e) => {
                          e.preventDefault();
                          append({ text: "", link: "", target: "", order: "" })
                        }

                        }
                      >
                        Add
                      </Button>
                    </Tooltip>
                  </Toolbar>
                </Grid>
              </div>
            </div>
            <hr className="mt-3" />
          </Col>
          <Col lg={6}>
            <div className="toggle_btn text-center mt-3 mb-2 buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('seoData')}> Create SEO Data  {columnVisibility.seoData ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}</div>
            <div className="mt-1" style={{ display: columnVisibility.seoData ? 'block' : 'none' }}>
              <div className="column">
                <Controller
                  name={`seo_title`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Enter SEO Title*"
                      {...field}
                      id="outlined-required"
                      className={`w-100 mb-2 ${errors?.seo_title ? "error" : ""
                        }`}
                    />
                  )}
                />
              </div>
              <div className="column">
                <Controller
                  name={`seo_description`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Enter SEO Discription*"
                      {...field}
                      id="outlined-required"
                      className={`w-100 mb-2 ${errors?.seo_description ? "error" : ""
                        }`}
                    />
                  )}
                />
              </div>
              <div className="column">
                <Controller
                  name={`seo_keywords`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Enter SEO Keywords*"
                      {...field}
                      id="outlined-required"
                      className={`w-100 mb-2 ${errors?.seo_keywords ? "error" : ""
                        }`}
                    />
                  )}
                />
              </div>
              <div className="column mb-3">
                <div className="toggle_btn text-center">Share Images</div>
                <div className="d-flex justify-content-around">
                  <Button
                    variant="contained"
                    component="label"
                    {...register('share_image.file')}
                  >
                    Share Image
                    <input
                      type="file"
                      {...register('share_image.file')}
                      hidden
                      onChange={(e) => handleImage("share_image", e)}
                      className={`file_button mb-1 ${errors.share_image && errors?.share_image?.file ? "error" : ""}`}
                    />
                  </Button>
                  <ImageWithDeleteButton logoName={`share_image.image`} watch={watch} setValue={setValue} />
                  {!watch(`share_image`)?.image ? <Button variant="contained" component="label" onClick={() => GetImage("share_image")} >Use Images </Button> : ""}
                </div>
                <div className="text-center">
                  {!watch(`share_image`)?.image && <p className="text-center mt-2 mb-0 text-secondary" style={{ fontSize: "10px" }}>File size 50KB and Intrinsic size is 400*150px.</p>}
                </div>
              </div>
              <div className="column mb-3">
                <div className="toggle_btn text-center">Favicon Images</div>
                <div className="d-flex justify-content-around">
                  <Button
                    variant="contained"
                    component="label"
                    {...register('favicon.file')}
                  >
                    Favicon Image
                    <input
                      type="file"
                      {...register('favicon.file')}
                      hidden
                      onChange={(e) => handleImage("favicon", e)}
                      className={`file_button mb-1 ${errors.favicon && errors?.favicon?.file ? "error" : ""}`}
                    />
                  </Button>
                  <ImageWithDeleteButton logoName={`favicon.image`} watch={watch} setValue={setValue} />
                  {/* {console.log(watch(`favicon`), "hello")} */}
                  {!watch(`favicon`)?.image ? <Button variant="contained" component="label" onClick={() => GetImage("favicon")} >Use Images </Button> : ""}
                </div>
                <div className="text-center">
                  {!watch(`favicon`)?.image && <p className="text-center mt-2 mb-0 text-secondary" style={{ fontSize: "10px" }}>File size 50KB and Intrinsic size is 400*150px.</p>}
                </div>
              </div>
              <div className="column">
                <Controller
                  name={`share_title`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Enter Share Title*"
                      {...field}
                      id="outlined-required"
                      className={`w-100 mb-2 ${errors?.share_title ? "error" : ""
                        }`}
                    />
                  )}
                />
              </div>
              <div className="column">
                <Controller
                  name={`share_description`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Enter Share Description*"
                      {...field}
                      id="outlined-required"
                      className={`w-100 mb-2 ${errors?.share_description ? "error" : ""
                        }`}
                    />
                  )}
                />
              </div>
              <div className="column mb-2">
                <Controller
                  name="seoDone"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      control={<Checkbox {...field} checked={field?.value} />}
                      label="Seo Data Done"
                    />
                  )}
                />
              </div>
            </div>
            <hr className="mt-3" />
          </Col>
        </Row>


        <Row>
          <Col>
            <div className="mt-4">
              <Controller
                name="pay_method" // Field name
                control={control} // React Hook Form control object
                defaultValue="" // Set default value here if needed
                render={({ field }) => (
                  <TextField
                    select
                    label="Select Your Payment Method *"
                    {...field} // Spread the field object from Controller
                    className={`w-100 mt-4  ${errors.pay_method ? "error" : ""}`}
                  >
                    <MenuItem value="razorPay">Razor Pay</MenuItem>
                    <MenuItem value="payU">PayU</MenuItem>
                  </TextField>
                )}
              />
            </div>
          </Col>

        </Row>
        <hr />
        <Row>
          <Col>
            <div className="">
              <Controller
                name="campaign_type" // Field name
                control={control} // React Hook Form control object
                defaultValue="" // Set default value here if needed
                render={({ field }) => (
                  <TextField
                    select
                    label="Select Campaign Type *"
                    {...field} // Spread the field object from Controller
                    className={`w-100 mt-4  ${errors.campaign_type ? "error" : ""}`}
                  >
                    <MenuItem value="Internal">Internal</MenuItem>
                    <MenuItem value="External">External</MenuItem>
                  </TextField>
                )}
              />
            </div>

          </Col>
          <Col>
            <div className="">
              <Controller
                name="uiType"
                control={control}
                defaultValue="" // Set default value here if needed
                render={({ field }) => (
                  <TextField
                    select
                    label="Select UI Type *"
                    {...field}
                    className={`w-100 mt-4  ${errors.uiType ? "error" : ""}`}
                  >
                    <MenuItem value="external">External</MenuItem>
                    <MenuItem value="plutoshome">Plutoshome</MenuItem>
                  </TextField>
                )}
              />
            </div>
          </Col>
        </Row>
        <Grid className="d-flex justify-content-between">
          <Toolbar className="p-0">
            <Button
              // color="inherit"
              className="button "
              variant="contained"
              disabled={activeStep === 0}
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              Back
            </Button>
          </Toolbar>
          <Toolbar className="p-0">
            <Button
              className="button "
              variant="contained"
              disableElevation
              endIcon={<NavigateNextIcon />}
              type="submit"
            // onClick={handleNext}
            >
              Save & Next
            </Button>
          </Toolbar>
        </Grid>
      </form>
      <ImageModal open={open} handleClose={handleClose} handleUrlChanges={handleUrlChanges} />
    </div >
  );
};

export default HeaderCreation;